// extracted by mini-css-extract-plugin
module.exports = {"figura":"Charmander_figura__14Rz1","ajuste":"Charmander_ajuste__37ld1","link":"Charmander_link__1ZNyc"};